import { Filters } from 'types/general'

import DesktopFilterBar from './DesktopFilterBar'
import MobileFilterBar from './MobileFilterBar'

type FilterBarProps = {
  filters: Filters
  filterOptions: any
  setFilters: (filters: Filters) => void
  /** @deprecated Filters apply automatically on change. Kept for mobile sheet close hooks. */
  onFilter?: () => void
  onReset?: () => void
  hasAppliedFilters: boolean
  /** Force a layout regardless of viewport (preferred over isMobile heuristics). */
  variant?: 'desktop' | 'mobile'
}

const FilterBar = ({
  filterOptions,
  filters,
  setFilters,
  onFilter,
  onReset,
  hasAppliedFilters,
  variant = 'desktop',
}: FilterBarProps) => {
  const handleChange = (key: string, value: any) => {
    const updated = { ...filters, [key]: value }
    setFilters(updated)
  }

  if (!filters) return null

  if (variant === 'mobile') {
    return (
      <MobileFilterBar
        filterOptions={filterOptions}
        filters={filters}
        setFilters={setFilters}
        handleChange={handleChange}
        onFilter={onFilter}
        onReset={onReset}
        hasAppliedFilters={hasAppliedFilters}
      />
    )
  }

  return (
    <DesktopFilterBar
      filterOptions={filterOptions}
      filters={filters}
      setFilters={setFilters}
      handleChange={handleChange}
      onReset={onReset}
      hasAppliedFilters={hasAppliedFilters}
    />
  )
}

export default FilterBar
